module.exports = __webpack_public_path__ + "img/2018.03.0c92441a.jpg";